'use client'

import PageFooter from '@/app/[locale]/page/[slug]/components/page-footer'
import { ShortcodeRenderer } from '@/components/common/cxp/shortcode-renderer'
import { ParsedContent } from '@/lib/helpers/shortcode-parser'
import { validateAndFixHtml } from '@/lib/helpers/validate-html'

interface PageContentProps {
  detail: {
    head_html?: string | null
    footer_html?: string | null
    body_html: ParsedContent[]
  } | null
  isLoading?: boolean
}

export function PageContent({ detail, isLoading }: PageContentProps) {
  if (isLoading) {
    return (
      <div className='flex min-h-[400px] items-center justify-center'>
        <div className='text-center'>
          <div className='mb-4 h-8 w-48 animate-pulse rounded bg-neutral-200' />
          <div className='h-64 w-full animate-pulse rounded bg-neutral-100' />
        </div>
      </div>
    )
  }

  if (!detail) {
    return (
      <div className='flex min-h-[400px] items-center justify-center'>
        <p className='text-neutral-600'>Không tìm thấy nội dung</p>
      </div>
    )
  }

  const { html: fixedHeadHtml } = validateAndFixHtml(
    'head_html',
    detail.head_html || ''
  )
  const { html: fixedFooterHtml } = validateAndFixHtml(
    'footer_html',
    detail.footer_html || ''
  )

  return (
    <div className='page-wrapper-css'>
      <PageFooter footerHtml={fixedFooterHtml} />
      <div dangerouslySetInnerHTML={{ __html: fixedHeadHtml }} />
      <ShortcodeRenderer content={detail.body_html} />
    </div>
  )
}
